import Tags from './tags'
import Options from './options'

export default {
  Tags,
  Options,
}
